<!-- icono -->
<div class="icono" *ngIf="tipoIcono == TipoIconoEnum.AweSomeFont">
  <span class="fa {{icono}}"></span>
</div>

<div class="icono" *ngIf="tipoIcono == TipoIconoEnum.Svg && icono" >
  <svg-icon class="iconoSVG" src="data:image/svg+xml;base64,{{icono}}">
  </svg-icon>
</div>
